import moment from 'moment';
import __ from 'utils/i18n';
import { MAX_DAYS_DOWNLOAD, MAX_DAYS_VIEW } from '../constants';

/**
 * Valida un rango de fechas para exportación
 * @param {string|moment.Moment} start - Fecha de inicio
 * @param {string|moment.Moment} end - Fecha de fin
 * @returns {string|null} - Mensaje de error o null si es válido
 */
export const validateExportDateRange = (start, end) => {
  const startMoment = moment(start).startOf('day');
  const endMoment = moment(end).startOf('day');
  const today = moment().startOf('day');
  const diffDays = endMoment.diff(startMoment, 'days');

  // Validar primero el rango inválido (fecha inicio después de fin)
  if (startMoment.isAfter(endMoment)) {
    return __('dashboard.sections.movements.filters.invalidRangeError');
  }

  // Validar días máximos ANTES de validar fecha futura (prioridad)
  if (diffDays > MAX_DAYS_DOWNLOAD) {
    return __('dashboard.sections.movements.export.maxDaysError', { days: MAX_DAYS_DOWNLOAD });
  }

  // Validar fecha futura solo si el rango es válido y no excede días máximos
  if (endMoment.isAfter(today)) {
    return __('dashboard.sections.movements.filters.futureDateError');
  }

  return null;
};

/**
 * Valida un rango de fechas para visualización
 * @param {string|moment.Moment} start - Fecha de inicio
 * @param {string|moment.Moment} end - Fecha de fin
 * @returns {string|null} - Mensaje de error o null si es válido
 */
export const validateViewDateRange = (start, end) => {
  const startMoment = moment(start).startOf('day');
  const endMoment = moment(end).startOf('day');
  const today = moment().startOf('day');
  const diffDays = endMoment.diff(startMoment, 'days');

  // Validar primero el rango inválido (fecha inicio después de fin)
  if (startMoment.isAfter(endMoment)) {
    return __('dashboard.sections.movements.filters.invalidRangeError');
  }

  // Validar días máximos para visualización
  if (diffDays > MAX_DAYS_VIEW) {
    return __('dashboard.sections.movements.filters.maxDaysError', { days: MAX_DAYS_VIEW });
  }

  // Validar fecha futura
  if (endMoment.isAfter(today)) {
    return __('dashboard.sections.movements.filters.futureDateError');
  }

  return null;
};

/**
 * Calcula la diferencia de días entre dos fechas (inclusive)
 * @param {string|moment.Moment} start - Fecha de inicio
 * @param {string|moment.Moment} end - Fecha de fin
 * @returns {number} - Diferencia de días + 1 (inclusive)
 */
export const calculateDaysDifference = (start, end) => {
  return moment(end).diff(moment(start), 'days') + 1;
};
